// src/services/accessClient.ts
import { httpsCallable, type HttpsCallableResult } from 'firebase/functions';
import { functions } from '../lib/firebase';
import { isProbablyNetworkError } from './netSafe';

function fakeResult<T>(data: T): HttpsCallableResult<T> {
  return { data } as HttpsCallableResult<T>;
}

/**
 * Safe callable wrapper:
 * - never throws
 * - returns { data: { ok:false, error } } on failure
 * - converts network/CORS/blocked fetch into a soft failure
 */
function safeCallable<TReq extends Record<string, unknown> = Record<string, never>, TRes extends { ok: boolean; error?: string } = { ok: boolean; error?: string }>(
  name: string,
) {
  const fn = httpsCallable<TReq, TRes>(functions, name);

  return async (payload?: TReq): Promise<HttpsCallableResult<TRes>> => {
    try {
      return await fn((payload ?? {}) as TReq);
    } catch (e: any) {
      const error = isProbablyNetworkError(e)
        ? 'network_blocked'
        : e?.message ?? String(e);

      console.warn(`[accessClient] ${name} failed; soft-failing`, e);
      return fakeResult({ ok: false, error } as TRes);
    }
  };
}

export const cfBootstrapMemberAndAccess = safeCallable<
  { inviteCode?: string; code?: string },
  {
    ok: boolean;
    uid?: string;
    memberNumber?: number;
    accessStatus?: 'active' | 'member' | 'waitlisted' | 'blocked';
    waitlistNumber?: number;
    error?: string;
  }
>('bootstrapMemberAndAccess');

export const cfSubmitWaitlistRequest = safeCallable<
  { email: string; name?: string; notes?: string },
  { ok: boolean; error?: string }
>('submitWaitlistRequest');
